function ChangeUsername() {
    /// <summary>
    /// This object provides common functions for the Widget.Membership.ChangeUsername.vb <br/>
    /// Author: AFU<br />
    /// Date: 19.7.2023<br />
    /// Copyright ©: EUDT GmbH 2023 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 19.7.2023                                               *<br />
    /// **********************************************************************<br />
    /// * - inherited from Widget.Membership.RegistrationEmail               *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.uid = -1;
}
ChangeUsername.prototype = new RegEmail();

ChangeUsername.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, click handler and buttons.
    /// </summary>
  var me = this;
    try {

     
        if (me.error) { return false; }
        me.showInfo("", "", false);
     

        me.visual.find(".info,#btnSend, #divSelection").hide();
      
        var div = $("<div>").attr("id", "div-change-username");
        div.append("<b>" + me.resources.pleaseEnterNewUsername + "</b><br/><br/>");

    
        div.append($("<input>").attr("id", "txt-new-name").addClass("txtEnabled").width(220).css("padding", "5px"));
        div.append("<br/><br/><div class='info'>" + me.resources.logoutAndRegEmail +"<br></div>");
        div.append("<div id='div-error' class='error vc-grid-margin-top vc-grid-margin-bottom' style='display:none;'></div>");
        var btn = $("<div>").attr("id", "btn-change-username").html( me.resources.changeUsername).button();
        div.append(btn);

        btn.on("click", function () { me.changeUsername();});

        me.visual.append(div);
        me.visual.append("<div id='div-loading' style='display:none;'>" + me.vcC.getLoadingIcon() + "</div>");


        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};



ChangeUsername.prototype.changeUsername = function () {
    /// <summary>
    /// This function changes the user name and then loads the hidden registration email
    /// </summary>
    var me = this;
   
    try {
        if (me.error) {
            return false;
        }

        var user = me.visual.find("#txt-new-name").val();


        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 99, 'id': me.id, 'NewUsername': user }),
            function (result) {
                if (result === null) { me.showMessage(me.resources.err_loadData, true);return false;}

                if (result.length > 0) {
                    me.visual.find("#div-error").html(result).show();
                } else {
                    me.visual.find("#div-error").html("").hide();
                    me.setState(true);
                    me.load();
                }
              
                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('changeUsername', ex);
        return false;
    }
};

ChangeUsername.prototype.setState = function (ok) {
    /// <summary>
    /// This function sets state while 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        if (ok) {
            me.visual.find("#div-change-username").hide();
            me.visual.find("#div-loading").show();
        } else {
            me.visual.find("#div-loading").hide();
            me.visual.find("#div-change-username").show();
            me.showMessage(me.resources.err_code, true);
        }


    } catch (ex) {
        me.writeError('setState', ex);
        return false;
    }
};


ChangeUsername.prototype.load = function () {
    /// <summary>
    /// This function fills the email content. 
    /// </summary>
    var me = this;
    var langid;
    var brand;
    try {
        if (me.error) {
            return false;
        }
        langid = parseInt(me.visual.find("#ddlLanguage").val(), 10);
        brand = me.visual.find("#ddlBrands").val();
       
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({'type':0, 'id': me.id, 'langid': langid, 'brand':brand }),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    me.setState(false);
                    return false;
                }
                me.visual.find('#txtSubject').val(result.Subject);
                //set the content and update the cleditor
                me.visual.find('#txtBody').val(result.Body).blur();
               
                me.send();
                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('reload', ex);
        return false;
    }
};


ChangeUsername.prototype.send = function () {
    /// <summary>
    /// This function sends the registration email
    /// </summary>
    var me = this;
    var email = {};
    var langid;
    var brand;
    try {
        if (me.error) { return false;}
       
        langid = parseInt(me.visual.find("#ddlLanguage").val(), 10);
        brand = me.visual.find("#ddlBrands").val();
       
        email.subject = me.visual.find("#txtSubject").val(); 
        email.body = me.visual.find("#txtBody").val();
        email.sendEmailtoMe = me.visual.find("#chbSendEmailToMe").is(":checked");
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify({'id': me.id, 'langid': langid, 'brand':brand }), '', me.deviceType, me.langid, JSON.stringify(email),
            function (result) {
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);
                    me.setState(false);
                    return false;
                }

                window.location.replace('../Appuser/Logout.aspx');
                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('send', ex);
        return false;
    }
};


